var React = require('react');

function D (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.494629 34H3.13464C6.59964 34 9.43761 34.66 12.3416 34.66C22.5056 34.66 27.3236 26.542 27.3236 17.5C27.3236 8.45797 22.5056 0.339966 12.3416 0.339966C9.43761 0.339966 6.59964 0.999969 3.13464 0.999969H0.494629V1.32997C3.33263 1.32997 3.53064 3.67297 3.53064 10.174V24.826C3.53064 31.327 3.33263 33.67 0.494629 33.67V34ZM6.33563 1.72597C8.24963 1.13197 10.1637 0.801968 12.3087 0.801968C20.4597 0.801968 24.4857 8.49097 24.4857 17.5C24.4857 26.509 20.4597 34.198 12.3087 34.198C10.1637 34.198 8.24963 33.868 6.33563 33.274V1.72597Z","fill":"currentColor"}));
}

D.defaultProps = {"width":"28","height":"35","viewBox":"0 0 28 35","fill":"none"};

module.exports = D;

D.default = D;
